import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_ME_QUERY_KEY } from './useGetMe';

import CustomerService, { UploadLogoDto } from '@/services/CustomerService';

export function useUploadLogo() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (uploadLogoDto: UploadLogoDto) => {
      return CustomerService.uploadLogo(uploadLogoDto);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_ME_QUERY_KEY,
      });
    },
  });

  return {
    uploadLogo: mutateAsync,
    isLoading: isPending,
  };
}
